module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/adBadge.a1b9517f.svg";